<template>
    <div class="exchange">
        <div class="exchange-container">
            <div class="goods-title"> 
                <div :class="{'title-name':chooseGifts.card.card_value,'title-name1':true}">{{chooseGifts.card.card_name}}</div>
                <div class="good-price" v-show="chooseGifts.card.card_value">{{chooseGifts.card.card_value}}型</div>
            </div>
            <div class="goods-list">
                <van-radio-group v-model="radio" >
                    <div class="goods-item" v-for="(item,index) in chooseGifts.combo" :key="item.combo_id">
                        <van-radio :disabled="item.combo_enable==0" @click="onSeeGoods1(item)" :name="item.combo_id"  icon-size='18px'>
                             <div class="combo_title">{{item.combo_title}}</div>
                         </van-radio>
                        <div class="goods-item-1" @click="onSeeGoods(index,item)" ref="circle">
                            <span class="iconfont icon-yuanquan-you tu"></span>
                        </div>
                    </div>
                </van-radio-group>
            </div>
        </div>
        <div class="input-list">
            <div class="input-item">
                <div>收件人：</div>
                <input type="text"  @blur="inputBurl" placeholder="请输入收件人姓名" v-model="param.name">
            </div>
            <div class="input-item">
                <div>电话：</div>
                <input type="text"  @blur="inputBurl" placeholder="请输入收件人电话号码" v-model="param.tel">
            </div>
            <div class="input-item">
                <div>电话确认：</div>
                <input type="text"  @blur="inputBurl" placeholder="请再次输入收件人手机号" v-model="param.mobile_repeat">
            </div>
            <div class="input-item">
                <div>地区：</div>
                <div class="choose-adress"  @click="showPopup">
                    <span>{{provinceCity}}</span>
                    <span class="iconfont icon-ln_sanjiaoxia"  ref="p"></span>
                </div>
            </div>
            <div class="input-item">
                <div>详细地址：</div>
                <input type="text"  @blur="inputBurl" placeholder="请输入您的详细地址" v-model="param.adress">
            </div>
            <div class="eare-tip">
                部分地区暂不支持配送，给您带来不便，请谅解。
            </div>
            <div class="button">
                
                <div @click="submit" >
                     <button>提交</button>
                </div>
               
            </div>
            <!-- 选择省市区 -->
            <pick :tipText = 'areaTipText' :showPicker="showPicker" @showPopup="showPopup" />
            <!-- 查看兑换产品详情 -->
            <chooseGoods :showGoods='showGoods' :id="goodId" :goodDetailList='goodDetailList'  @onShowGoods='onSeeGoods' />
        </div>
    </div>
</template>
<script>
// import {mapState} from 'vuex'
import pick from '@components/Area/index'
import chooseGoods from  '@components/goods/chooseGoods'
import {apiDetail,apiCreate} from "@/api"
export default {
    components:{
        pick,
        chooseGoods
    },
    data() {
        return {
        goodId:null,
        param:{
            name:'',
            tel:'',
            area:'山东省 济南市 槐荫区',
            adress:'',
            mobile_repeat:"",//再次确认的手机号
        },
        confirmTel:"",
        goodsList:[],
        showPicker:false,
        provinceCity:'山东省 济南市 槐荫区',
        showGoods:false,
        goodsIndex:0,
        goodDetailList:{},
        chooseGifts:{},
        areaTipText:"该地区暂不支持配送，请选择其他地区。"
        };
     },
    created(){
        // console.log(this.$store.state)
        this.chooseGifts = JSON.parse(window.sessionStorage.getItem("storeChooseGifts")) 
        // console.log(this.chooseGifts,'chooseGifts')
    },
    destroyed(){
                this.$store.commit('changeRadio',{
                    radio:'',
                })
    },
     methods: {
        showPopup(e) {
            if(typeof(e) == 'string'){
                this.provinceCity = e
                this.param.area = e
            }
            this.showPicker = !this.showPicker;
         
            let p = this.$refs.p
            if(this.showPicker){
                p.classList.add('transfrom')
            }else{
                p.classList.remove('transfrom')
            }
        },
        /**
         * 查看产品详情
         */
         onSeeGoods(index,item){
           console.log(item,"id")
           
            let id;
            if(item){
                id = item.combo_id;
                this.goodId = item.combo_id;
            }
            
            if(index!=undefined) this.goodsIndex = index;
            let circle = this.$refs.circle;
            this.showGoods = !this.showGoods;
            if(this.showGoods){
                circle[this.goodsIndex].classList.add('transfrom1');
                this.apiDetail(id)
            }else{
                 circle[this.goodsIndex].classList.remove('transfrom1');
            }
            
        },
        /**
         * 选择产品
         */
        onSeeGoods1(item){
            console.log(item,"item");
            // 检测是否有库存
            // if(!this.onCheckGoodStock(item)){
            //     return;
            // }
            if(item.combo_tip==1){
                this.$dialog.alert({
                    message:item.combo_inventory_message,
                    messageAlign:"left",
                    allowHtml :true
                  }).then(() => {
                    // on close
                  });
            }
            if(item.combo_enable==0){
                return
            }
            //保存选中的产品
             this.$store.commit('changeRadio',{
                    radio:item.combo_id,
                })
        },
        
        async apiDetail(combo_id){
             this.goodDetailList={}
            const [err,data] = await apiDetail({
                combo_id:combo_id,
                key:this.chooseGifts.key,
                secret: this.chooseGifts.secret,
            })
            if(err) return console.warn(err)
            this.goodDetailList = data
        
            // const regex = new RegExp('<img', 'gi')
            // this.goodDetailList.product_content =this.goodDetailList.product_content
            this.goodDetailList.combo_content =this.formatRichText( this.goodDetailList.combo_content)
            //  this.goodDetailList.combo_title = this.changeTitle(this.goodDetailList.combo_title)
            // window.localStorage.setItem("detail",JSON.stringify(data));
        },
         formatRichText:function(html){
             if(!html){
                 return ''
             }
               const regex = new RegExp('<img', 'gi')
            let newContent= html.replace(regex, '<img style="max-width:100%;height:auto;display:block;"');
            // console.log(newContent,"KPnHk4C9")
            return newContent;
          },
          changeTitle:function(title){
            //   console.log(title,"title")
              if(!title){
                  return ''
              }
            //   console.log(title.indexOf('+'),"title.indexOf('+')")
              if(title.indexOf('+')=='-1'){
                  return [title]
              }
              return title.split("+")
          },
        submit(){
            let {name,tel,area,adress,mobile_repeat} = this.param
             if(!this.removeAllSpace(this.radio)) return this.$toast('请选择套餐');
                if(!this.removeAllSpace(name)) return this.$toast('请输入姓名');
                if(!this.removeAllSpace(tel)) return this.$toast('请输入手机号');
                if(this.removeAllSpace(tel).length!=11) return this.$toast('请输入正确的手机号');
                if(!this.removeAllSpace(mobile_repeat)) return this.$toast('请输入确认手机号');
                if(this.removeAllSpace(tel)!=this.removeAllSpace(mobile_repeat)){
                    return this.$toast("两次手机号不一致")
                }
                if(!area) return this.$toast('请选择地区');
                if(!this.removeAllSpace(adress)) return this.$toast('请输入详细地址');
               
            if(name&&tel&&area&&adress&&this.radio){
                let params={
                    key:this.chooseGifts.key,
                    secret:this.chooseGifts.secret,
                    province:this.provinceCity.split(' ')[0],
                    city:this.provinceCity.split(' ')[1],
                    county:this.provinceCity.split(' ')[2],
                    combo_id:this.radio,
                    address:this.param.adress,
                    mobile:this.param.tel,
                    name:this.param.name,
                    mobile_repeat:mobile_repeat//接口未定

                }
                console.log(params);
                // 暂时关闭提交
                // return 
              
                this.apiCreate(params);
            }

        },
        /**
         * 提交接口
         */
        async apiCreate(params){
            const [err,data] = await apiCreate(params)
            if(err) return console.warn(err)
             window.sessionStorage.setItem("SUCESSDATA",JSON.stringify(data));
              this.$router.push({
                    name:'ExchangeSucess'
                })
             this.$store.commit('changeRadio',{
                    radio:null
                })
        },
         removeAllSpace(str) {
             if(!str){
                 return
             }
            return str.replace(/\s+/g, "");
        },
    },
    computed:{
         radio:{
            get: function () { return this.$store.state.radio } ,
            set: function (id) { this.$store.commit('changeRadio',{
                    radio:id
                }) }

         }

    }


}
</script>
<style lang="scss" scoped>
    .exchange{
        .eare-tip{
            font-size: 30px;
            color:rgba(102,102,102,1);
            text-align: center;
            padding: 20px 0;
        }
        .transfrom{
             transform:rotate(180deg);
             transition: transform 0.5s ;
        }
        .transfrom1{
             transform:rotate(90deg);
             transition: transform 0.5s ;
        }
        .exchange-container{
            padding: 24px 26px;
            border-top: 6px solid #F9F9F9;
            border-bottom: 10px solid #F9F9F9;
            .goods-title{
                font-size:32px;
                font-family:PingFang SC;
                font-weight:500;
                color:rgba(68,68,68,1);
                padding:0 10px;
                padding-bottom: 17px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .title-name{
                    width: 75%;
                    
                }
                .title-name1{
                    line-height: 50px;      
                }
                .good-price{
                    width:25%;
                    font-size: 34px;
                    color: #ff4646;
                    text-align: right;
                    font-weight: bold;
                    box-sizing: border-box;
                    padding-left: 10px;
                }
                
            }
            .goods-list{
                width: 100%;
                box-sizing: border-box;
                padding:0 20px;
                padding-top: 38px;
                border-top: 2px solid #F9F9F9;
                .goods-item{
                    margin-bottom: 40px;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size:28px;
                    font-family:PingFang SC;
                    font-weight:500;
                    color:rgba(102,102,102,1);
                    line-height:40px;
                    .tu{
                        font-size: 30px;
                    }
                }
            }
        }
        .input-list{
            padding: 0 43px;
            padding-top: 45px;
            .input-item{
                font-size:28px;
                font-family:PingFang SC;
                font-weight:500;
                color:rgba(68,68,68,1);
                display: flex;
                align-items: center;
                margin-bottom: 26px;
                >div{
                    width: 146px;
                    text-align: right;
                }
                input{
                    width:454px;
                    padding: 0 18px;
                    height:68px;
                    background:rgba(255,255,255,1);
                    border:2px solid rgba(220,220,220,1);
                    border-radius:6px 6px 10px 6px;
                    &::placeholder{
                        color:#888888;
                    }
                }
                .choose-adress{
                    width:454px;
                    padding: 0 18px;
                    height:68px;
                    background:rgba(255,255,255,1);
                    border:2px solid rgba(220,220,220,1);
                    border-radius:6px 6px 10px 6px;
                    font-size:28px;
                    font-family:PingFang SC;
                    font-weight:500;
                    color:rgba(136,136,136,1);
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
            }
            .button{
                text-align: center;
                padding: 60px 0;
                button{
                width:619px;
                height:80px;
                background:linear-gradient(0deg,rgba(255,74,74,1),rgba(255,70,70,1));
                border-radius:40px;
                border: none;
                font-size:38px;
                font-family:PingFang SC;
                font-weight:500;
                color:rgba(255,255,255,1);

            }
            }
            
        }
        .combo_title{
            margin-right: 10px;
        }
    }
</style>